import CardsList from "@/components/cardsList";
import { VMWARE_SERVICES_CONSTANTS } from "./constants";

const ServicesComponent = () => {
  return (
    <CardsList
      columns={{ base: 1, sm: 2, md: 4 }}
      desc={VMWARE_SERVICES_CONSTANTS.desc}
      title={VMWARE_SERVICES_CONSTANTS.title}
      list={VMWARE_SERVICES_CONSTANTS.list}
      spacing={{ base: 8, md: 12 }}
    />
  );
};

export default ServicesComponent;
